<div class="serials-generation-progress-container">
  <key-spinner class="serials-generation-progress-spinner"></key-spinner>
  <div class="serials-generation-progress-info">
    <div class="serials-generation-progress-message">{{ 'App_PrintingInProgressMessage' | translate }}</div>
    <div>
      <span class="serials-generation-progress-label">{{ 'App_Progress' | translate }}: </span>
      <span>{{ percentage }}%</span>
    </div>
    <div>
      <span class="serials-generation-progress-label">{{ 'App_RemainingTime' | translate }}: </span>
      @if (estimatedTime === -1) {
        <span>{{ 'App_CalculatingMessage' | translate }}</span>
      }
      @if (estimatedTime > -1) {
        <span>{{ getEstimatedTime() }}</span>
      }
    </div>
  </div>
</div>
